<!--
 * @Description: 
 * @Author: Lynn Qin
 * @Date: 2021-04-12 16:25:13
 * @LastEditTime: 2021-12-27 14:46:28
-->
<template lang="pug">
    el-container.default-layout
        el-header
            pgc-header
        el-container
            el-aside(width="210px")
                pgc-sidebar
            .default-layout__content
                router-view
        el-dialog.index-dialog(center :visible.sync="!$store.getters['user/isNeedEdit'] && $route.path !== '/setting'" :append-to-body="false" width="240px" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false")
            .title {{$t('firstTimeLogin')}}
            el-button(type="primary" @click="$router.push('/setting')") {{$t('goToSettings')}}
</template>

<script>
import { Container, Header, Aside, Main } from 'element-ui'
import PgcHeader from '@/components/layout/pgc-header'
import PgcSidebar from '@/components/layout/pgc-sidebar'

export default {
    name: 'default-layout',
    data() {
        return {
            dialogVisible: true
        }
    },
    components: {
        [Container.name]: Container,
        [Header.name]: Header,
        [Aside.name]: Aside,
        [Main.name]: Main,
        PgcSidebar,
        PgcHeader
    }
}
</script>

<style lang="scss">
html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}
</style>

<style lang="scss" scoped>
.default-layout {
    .el-header{
        padding: 0;
        height: 50px !important;
        z-index: 1000;
        box-shadow: 0px 2px 10px 0px rgba(76, 28, 0, 0.2);
    }
    &__content {
        height: calc(100vh - 50px);
        width: calc(100vw - 200px);
        background: #FAF9F8;
        overflow: auto;
    }
    
    ::v-deep .index-dialog{
        display: flex;
        align-items: center;
        justify-content: center;
        .el-dialog__header{
            display: none;
        }
        .el-dialog--center{
            margin-top: 0 !important;
            .el-dialog__body {
            padding-top: 0;
            padding-bottom: 20px;
            text-align: center;
            .title{
                font-size: 16px;
                color: #666666;
                padding: 40px 0;
            }
            .el-button{
                padding: 12px 40px;
            }
        } 
    }
    } 
}
</style>
